module.exports = __webpack_public_path__ + "static/img/1.c5ea1f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/sp/1.png
// module id = hb+k
// module chunks = 0